<template>
  <youtube
    v-if="video.id"
    ref="youtube"
    :player-vars="playerVars"
    :video-id="videoId"
    class="w-full h-full"
    @ended="ended"
  />
</template>

<script>
import { Event, Type } from '@/src/server/helpers/constants'

export default {
  props: {
    video: {
      type: Object,
      default () {
        return {}
      },
      validator (value) {
        return !value.id || (value.type === Type.VIDEO && value.attributes && value.attributes.url)
      },
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    videoId () {
      if (this.video) {
        const videoUri = new this.$uri(this.video.attributes.url)
        const videoParams = this.$qs.parse(videoUri.query())

        return videoParams.v
      }
    },
    player () {
      if (this.video) {
        return this.$refs.youtube.player
      }
    },
    playerVars () {
      // INFO: https://developers.google.com/youtube/player_parameters?playerVersion=HTML5#Parameters
      return {
        color: 'white',
        modestbranding: 1,
        rel: 0,
      }
    },
  },

  updated () {
    this.autostart()
  },

  mounted () {
    this.autostart()
  },

  methods: {
    ended (payload) {
      this.$emit(Event.ENDED, payload)
    },
    autostart () {
      if (this.video && this.autoplay) {
        this.player.playVideo()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/Videos/VideoYoutube.vue